// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1018":"80eec3becf99058a","1646":"46aeee2c95737391","6423":"250a9274b8dc8aab","7769":"581ea2e87b98db5a","8116":"1b43d93de521f973"}[chunkId] + ".css";
};